export default __webpack_public_path__ + "static/deer-1-e0afbc30cefe11fb606b7e9cdbb8680c.png";